import { EventTypes } from '@racemap/sdk/schema/events';
import type { Price } from '../../components/CostCalculator/getProductPriceFactory';
import { basePriceMapping } from '.';
import { useGetProductPrice } from './useGetProductPrice';

export function useEventBasePrice(eventType = EventTypes.REGULAR): Price | undefined {
  const getPrice = useGetProductPrice();
  const stripPrice = basePriceMapping[eventType];
  if (stripPrice == null) return undefined;

  return getPrice?.(stripPrice, 1);
}
